
import { useContext, useState } from 'react'
import { AppContext } from '../../../contextApi/ContextApi';
import OrderCardDetails from './OrderCardDetails';

export default function OrderCard({order, client}) {
    const {accent_color, formatDate, calculateDaysPassed} = useContext(AppContext);
    const [detailsFlag, setDetailsFlag] = useState(false);
    return (
        <div className='orderCard'>
            <div className='orderCard_mainDetails' dir='rtl' onClick={()=>{setDetailsFlag(!detailsFlag)}}>
                <p><b>מס' הזמנה:</b> {order._id}</p>
                <p><b>תאריך הזמנה</b> {formatDate(order.orderTime)} ({calculateDaysPassed(order.orderTime)} ימים)</p>
                <p><b>סטטוס הזמנה: <span style={{color:order.status==="בטיפול" ? "yellow" : order.status==="בדרכה ליעד" ? "orange" : order.status==="התקבלה" ? "green" : accent_color}}>{order.status}</span></b></p>
            </div>
            <OrderCardDetails order={order} client={client} detailsFlag={detailsFlag}/>
        </div>
    )
}
